import {DOWNLOAD_REQUESTED, DOWNLOAD_SUCCESSED} from "../../components/product/list/list.actions";
import {fork, put, takeEvery} from "redux-saga/effects";
import {ApiService} from "../../api/api.service";
import {NotificationService} from "../../common/services/notification/notification.service";
import {API_CALL_ERROR} from "../action";
import {AppInjector} from "../../app-injector";

function* download(action) {
  try {
    const EXTENSION = `${action.data.extension ? action.data.extension : 'csv'}`;
    let result = null;
    // emit download api here
    if (action.data.type === 'product') {
      result = yield AppInjector.get(ApiService)[action.data.type].download(action.data.sort, action.data.filter, action.data.pagination.search)
        .toPromise();
    } else if (action.data.type === 'invoice') {
      result = yield AppInjector.get(ApiService).order.downloadInvoices(action.data.orders)
        .toPromise();
    } else if (action.data.type === 'delivery') {
      result = yield AppInjector.get(ApiService).delivery.downloadDeliveries(action.data.orderIds)
        .toPromise();
    } else if (action.data.type === 'payment') {
      result = yield AppInjector.get(ApiService)[action.data.type].download(action.data.sorts, action.data.filter, null)
        .toPromise();
    } else if (action.data.type === 'product_attributes') {
      result = yield AppInjector.get(ApiService).product.downloadAttributes()
        .toPromise();
    }
    yield put({ type: DOWNLOAD_SUCCESSED, data: result });
    AppInjector.get(NotificationService).show('info', `Processing your export, will redirect once it is done`, 2000);
    AppInjector.get(ApiService).general.asyncStatus(result.data, null, null).subscribe(s => {
      if (s !== 'Time out') {
        AppInjector.get(NotificationService).show('success', `File Ready <a href="${action.data.mediaPath}/export/${action.data.type}/${s}.${EXTENSION}" target="_blank">Click here if file is not downloaded</a>`, 10000, false, true);
        if (action.data.windowReference) {
          action.data.windowReference.location = `${action.data.mediaPath}/export/${action.data.type}/${s}.${EXTENSION}`;
          action.data.windowReference.focus();
        } else {
          window.open(`${action.data.mediaPath}/export/${action.data.type}/${s}.${EXTENSION}`,
            '_blank');
        }
      } else {
        AppInjector.get(NotificationService).show('warning', `file will take longer time to process`, 5000);
      }
    });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchDownloadRequest() {
  yield takeEvery(DOWNLOAD_REQUESTED, download);
}

export default [
  fork(watchDownloadRequest)
];
